import { ChangeExistingEmailArgs } from 'types/api/arguments/change-existing-email-args'

import { api } from './api'

export const changeExistingEmail = ({ email, userId }: ChangeExistingEmailArgs) =>
  api.put(`/users/${userId}/change_email`, { email })
